// ui/StateTag.tsx
type Tone = "pending" | "approved" | "rejected" | "overdue" | "default";

const MAP: Record<Tone, string> = {
    approved: "bg-green-100 text-green-700",
    pending: "bg-amber-100 text-amber-700",
    rejected: "bg-red-100 text-red-700",
    overdue: "bg-orange-100 text-orange-700",
    default: "bg-neutral-100 text-neutral-700",
};

export const StateTag = ({ v, tone }: { v: string; tone?: Tone }) => {
    const cls = (tone && MAP[tone]) ?? MAP.default;
    return (
        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cls}`}>{v}</span>
    );
};
